export const styles = () => ({
  root: {
    padding: "0 24px",
    marginTop: 12,
  },
});
